import { useEffect, useState } from "react";
import "./PackageDetailsTable.scss";
import { getSessionStorageItem } from "../../../../../utils/SessionStorageMethod/getSessionStorageItem";
// import { AssessmentButton } from "ui-components";
import {
  countCreditCheck,
  finalDiscountCredit,
} from "../../../../../utils/Common/Constant";
import CreditCoin from "../../../../../utils/Images/CreditCoin";
import { useTranslation } from "react-i18next";
// import { systemPreferenceContext } from "../../../../../context/SystemPreference/SystemPreference";

const PackageDetailsTable = ({
  // totalTableCredit,
  assessmentQuestionSet,
}: any) => {
  // const { preferenceData } = useContext(systemPreferenceContext);
  const [newData, setNewData] = useState<any>([]);
  // (start) total question count (that was used here || remove in future)
  // const [totalQuestion, setTotalQuestion] = useState<any>(0);
  // (end) total question count (that was used here || remove in future)
  const [grossTotal, setGrossTotal] = useState<any>(0);
  const { t } = useTranslation();
  // const [isPriceCal, setIsPriceCal] = useState<any>(false);
  const evaluationAiChecks = getSessionStorageItem("evaluation") ?? [];
  const UpdateEvaluation = evaluationAiChecks
    .filter((item: any) => item.type === "smartAi")
    .reduce((acc: any, curr: any) => ({ ...acc, ...curr }), {
      type: "smartAi",
    });
  const paymentDiscountPackage =
    getSessionStorageItem("paymentData")?.discountPacakgeDetails ?? {};
  const renderHeader = () => {
    const headerElement = [
      { label: "Type", className: "text-start" },
      { label: "Per Question Credits", className: "text-center" },
      { label: "Total Questions", className: "text-center" },
      { label: "Total", className: "text-end" },
    ];

    return headerElement.map(({ label, className }, index) => (
      <div className={`col-md-3 ${className}`} key={index}>
        {label.toUpperCase()}
      </div>
    ));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const customMCQ = {
        type: "Custom",
        unit: 0,
        totalQuestion: 0,
        credit: 0,
      };
      const {
        videoType,
        codingType,
        mcqEssayType,
        singleCustomType,
        multipleCustomType,
        essayCustomType,
        videoCustomType,
      } = countCreditCheck(
        assessmentQuestionSet,
        getSessionStorageItem("paymentData") ?? [],
      );

      let newData = [
        videoType,
        codingType,
        mcqEssayType,
        singleCustomType,
        multipleCustomType,
        essayCustomType,
        videoCustomType,
      ]
        .map((item: any) => {
          if (["Single", "Multiple", "Essay"].includes(item.type)) {
            customMCQ.unit = item?.unit;
            customMCQ.totalQuestion += item?.totalQuestion;
            customMCQ.credit += item.credit;
            return null;
          }
          return item;
        })
        .filter((item: any) => item !== null);

      newData.push(customMCQ);
      newData = newData.filter((item: any) => item.totalQuestion !== 0);
      // Calculate total number of questions and cross total
      // const totalQuestions = newData.reduce(
      //   (acc: number, item: any) => acc + item?.totalQuestion,
      //   0,
      // );
      const crossTotal = newData.reduce(
        (acc: number, item: any) => acc + item?.credit,
        0,
      );
      setNewData(newData);
      // setTotalQuestion(totalQuestions);
      setGrossTotal(crossTotal);
    }, 1000); // 1000 ms interval = 1 second

    return () => clearInterval(interval); // Clear the interval when the component is unmounted or dependencies change
  }, []);

  const checkAiEnable = (aiData: any) => {
    const paymentPackage =
      getSessionStorageItem("paymentData")?.packageDetails ?? {};

    const { aiAnalysis, visualAnalysis, audioAnalysis } = aiData;
    if (aiAnalysis && visualAnalysis && audioAnalysis) {
      const videoCredit =
        paymentPackage?.creditForAIAnalysisVideoQuestion +
        paymentPackage?.creditForManualAnalysisVideoQuestion +
        paymentPackage?.creditForVisualAnalysisVideoQuestion +
        paymentPackage?.creditForVoiceAnalysisVideoQuestion;
      return {
        creditUnit: videoCredit,
        creditText: "(Manual+AI+Visual+Voice)",
        creditUnitText: `${paymentPackage?.creditForManualAnalysisVideoQuestion} + ${paymentPackage?.creditForAIAnalysisVideoQuestion} + ${paymentPackage?.creditForVisualAnalysisVideoQuestion} + ${paymentPackage?.creditForVoiceAnalysisVideoQuestion} = ${videoCredit}`,
      };
    } else if (aiAnalysis && visualAnalysis) {
      const videoCredit =
        paymentPackage?.creditForAIAnalysisVideoQuestion +
        paymentPackage?.creditForManualAnalysisVideoQuestion +
        paymentPackage?.creditForVisualAnalysisVideoQuestion;
      return {
        creditUnit: videoCredit,
        creditText: "(Manual+AI+Visual)",
        creditUnitText: `${paymentPackage?.creditForManualAnalysisVideoQuestion} + ${paymentPackage?.creditForAIAnalysisVideoQuestion} + ${paymentPackage?.creditForVisualAnalysisVideoQuestion} = ${videoCredit}`,
      };
    } else if (aiAnalysis && audioAnalysis) {
      const videoCredit =
        paymentPackage?.creditForAIAnalysisVideoQuestion +
        paymentPackage?.creditForManualAnalysisVideoQuestion +
        paymentPackage?.creditForVoiceAnalysisVideoQuestion;
      return {
        creditUnit: videoCredit,
        creditText: "(Manual+AI+Voice)",
        creditUnitText: `${paymentPackage?.creditForManualAnalysisVideoQuestion} + ${paymentPackage?.creditForAIAnalysisVideoQuestion} + ${paymentPackage?.creditForVoiceAnalysisVideoQuestion} = ${videoCredit}`,
      };
    } else if (aiAnalysis) {
      const videoCredit =
        paymentPackage?.creditForAIAnalysisVideoQuestion +
        paymentPackage?.creditForManualAnalysisVideoQuestion;
      return {
        creditUnit: videoCredit,
        creditText: "(Manual+AI)",
        creditUnitText: `${paymentPackage?.creditForManualAnalysisVideoQuestion} + ${paymentPackage?.creditForAIAnalysisVideoQuestion} = ${videoCredit}`,
      };
    } else {
      const videoCredit = paymentPackage?.creditForManualAnalysisVideoQuestion;
      return {
        creditUnit: videoCredit,
        creditText: "(Manual)",
        creditUnitText: `${paymentPackage?.creditForManualAnalysisVideoQuestion}`,
      };
    }
  };

  return (
    <div>
      <div className="priceCal">
        <h6 className="cursorPointer">
          {t("CREATED_ASSESSMENT_PRICE_CALCULATION")}
        </h6>
        <div className="d-flex flex-column gap-1 mb-3">
          <span className="showCredit">
            <div className="discountWithShowCredit">
              <CreditCoin width={28} height={28} />
              <ins>
                {finalDiscountCredit() === 0
                  ? getSessionStorageItem("totalCountedCredit")
                  : finalDiscountCredit()}
              </ins>
              <del>
                {finalDiscountCredit() === 0
                  ? null
                  : getSessionStorageItem("totalCountedCredit")}
              </del>
            </div>
          </span>
        </div>
      </div>
      {grossTotal > 0 && (
        <div className="calculateCreditUse">
          <div className="headContent row">{renderHeader()}</div>
          <div className="usageDetailsHead">
            {newData?.map((item: any, index: number) => {
              return (
                <div key={index} className="usageDetails row">
                  {item?.type === "Video" ? (
                    <span className="videoAi flex-fill col-md-3">
                      <span>{item?.type}</span>
                      <span>
                        {checkAiEnable(
                          UpdateEvaluation ?? {
                            aiAnalysis: false,
                            visualAnalysis: false,
                            audioAnalysis: false,
                          },
                        )?.creditText ?? ""}
                      </span>
                    </span>
                  ) : item?.type === "McqEssay" ? (
                    <span className="flex-fill col-md-3">
                      {t("CREATED_ASSESSMENT_MCQ")}
                    </span>
                  ) : item?.type === "CustomVideo" ? (
                    <span className="flex-fill col-md-3">
                      {t("CREATED_ASSESSMENT_CUSTOM_VIDEO")}
                    </span>
                  ) : (
                    <span className="flex-fill col-md-3">{item?.type}</span>
                  )}

                  {item?.type === "Video" ? (
                    <span className="flex-fill col-md-3 text-center">
                      {checkAiEnable(
                        UpdateEvaluation ?? {
                          aiAnalysis: false,
                          visualAnalysis: false,
                          audioAnalysis: false,
                        },
                      )?.creditUnitText
                        ? checkAiEnable(
                            UpdateEvaluation ?? {
                              aiAnalysis: false,
                              visualAnalysis: false,
                              audioAnalysis: false,
                            },
                          )?.creditUnitText
                        : 0}
                    </span>
                  ) : (
                    <span className="flex-fill col-md-3 text-center">
                      {item?.unit}
                    </span>
                  )}
                  <span className="flex-fill col-md-3 text-center">
                    {item?.totalQuestion}
                  </span>
                  {item?.type === "Video" ? (
                    <span className="flex-fill col-md-3 text-end">
                      {item?.credit}
                    </span>
                  ) : (
                    <span className="flex-fill col-md-3 text-end">
                      {item?.unit * item?.totalQuestion}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
          <div className="headContent footerContent row">
            <div className="dirDown col-md-4">
              <span>
                <strong>{t("CREATED_ASSESSMENT_TOTAL")}</strong>
              </span>
              <p>
                <strong>{grossTotal}</strong>
              </p>
            </div>
            {paymentDiscountPackage?.percentage > 0 && (
              <div className="dirDown col-md-4">
                <span>
                  <strong>{t("CREATED_ASSESSMENT_DISCOUNT")}</strong>
                </span>
                <p>
                  <strong>{paymentDiscountPackage?.percentage}%</strong>
                </p>
              </div>
            )}

            <div className="dirDown col-md-4">
              <span>
                <strong>{t("CREATED_ASSESSMENT_GRAND_TOTAL")}</strong>
              </span>
              <p>
                <strong>
                  {finalDiscountCredit() === 0
                    ? getSessionStorageItem("totalCountedCredit")
                    : finalDiscountCredit()}
                </strong>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PackageDetailsTable;
